import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import './detail.css'

import {userList} from '../../redux/chatuser.redux.js'
import {authenticationFn} from '../../redux/chatuser.redux.js'
import {authenMsg} from '../../redux/chatuser.redux.js'

import ToastBar from '../../component/toast/toast.js'
import {getElementPosition} from '../../util.js'

import HeaderPC from '../../component/headerPC/headerPC.js'
import AuthenticatePC from '../../component/authenticate-pc/authenticate.js'
import ReturnListPC78 from '../../component/return-list-pc/return-list-78.js'
import ReturnListPC89 from '../../component/return-list-pc/return-list-89.js'
import ReturnListPC7910 from '../../component/return-list-pc/return-list-7910.js'
import ReturnListPC from '../../component/return-list-pc/return-list.js'

import ReturnGetALert from '../../component/return-get-alert/alert.js'
import ReturnGetALert7910 from '../../component/return-get-alert/alert7910.js'
import ReturnGetALert78 from '../../component/return-get-alert/alert78.js'

@connect(
    state=>state.chatuser,
    {userList,authenticationFn,authenMsg}
  )

class returnDetailPC extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            gameInfo:'',
            money: '',
            asideNum:0,
            detailVla: '',
            accountData: '',
            showSelectWelfare:false,
            parmeKey:''
        }

        
    	this.gameXiaoHao = '回归消耗累积金额'
        this.game_id = this.props.match.params.id
        this.handleVla = this.handleVla.bind(this)
        this.propsAuthenticationData = this.propsAuthenticationData.bind(this)
        this.ToastBarClose = this.ToastBarClose.bind(this)
        
    	this.moneyArr = []
        
    	this.asideData =['账号鉴定','定制礼包','消耗福利','返回首页']
        
    	if(this.props.match.params.id==='89'){
    		this.asideData =['账号鉴定','定制礼包','消耗福利','返回首页','更多福利']
    	}
        
    	if(this.game_id==='791000306'){
    		this.gameXiaoHao = '回归充值累积金额'
    	}
    }
    componentDidMount(){
        this.getGameInfo();
    	this.handleGetMoney()

        this.setState({
    		showSelectWelfare:false,
    		parmeKey:''
    	})
    }
    propsAuthenticationData(data){
        this.setState({
            accountData:data
        })
    }
    componentWillReceiveProps(nextProps){
  		
        this.setState({
            showSelectWelfare:false
        })
      if(this.props.match.params.id!==nextProps.match.params.id){
            this.setState({
                parmeKey:nextProps.match.params.id,
                showSelectWelfare:false
            })
            this.game_id = nextProps.match.params.id
            this.getGameInfo()
            this.handleGetMoney()
      }
      
    }
    getGameInfo(){
		axios.get('/fapi/recom/getGameInfo?game_id='+this.game_id+'')
			.then(res=>{
				if(res.data.return_code===0){
					this.setState({
						gameInfo:res.data.data
					})
				}else{
					alert('游戏还未开放回归特权，敬请期待')
					const iUrl = window.location.origin
					window.location.href=iUrl+'/return-pc'
					//this.props.history.push('/return-m')
				}
			})
    }
    
	handlePower(num){
        var num = parseFloat(num)
  		
  		if(this.game_id==='89'){
  			this.moneyArr = ['1','200','500','1000','3000']
			
  			for(var i=0;i<this.moneyArr.length;i++){
  				if(num&&num<this.moneyArr[i]){
                      return 20 * i + '%';
  					// return 120/(this.moneyArr.length-1)*(i-1)+1+'%'
	  			}
	  			if(num&&num>=this.moneyArr[4]){
	  				return '100%'
	  			}
  				
  			}
			
  		}else if(this.game_id==='791000306'){
			if(num>=1&&num<1000){
				return '0.3rem'
			}else{
				if(num>10000){num=10000}
				return  num/10000*7+'rem'
			}
			

  		}else{
  			this.moneyArr = ['1','1000','5000']

  			for(var i=0;i<this.moneyArr.length;i++){
  				if(num&&num<this.moneyArr[i]){
                    return 30 * i + '%';
  					// return 4.9/(this.moneyArr.length-1)*(i-1)+1+'rem'
	  			}
	  			if(num&&num>=this.moneyArr[2]){
	  				return '100%'
	  			}
  				
  			}
  			
  		}
  	}
    handleLogin(){	
        if(this.props.userlist.code===-1){
            const pathname = this.props.location.pathname
          axios.get('/fapi/getLoginURL?redirect_url='+encodeURIComponent(encodeURIComponent(window.location.href)))
            .then(res=>{
                 if(res.data.return_code==0){
                     window.location.href = res.data.redirect_url
                 }		     
           })		
        }	
    }
    handleGetMoney(){
		axios.get('/fapi/recom/getMoney?game_id='+this.game_id+'')
  			.then(res=>{
                if(this.props.userlist.code===-1){
                        this.setState({
                            money:'点击查看'
                        })
                }else{
                    this.setState({
                        money:res.data.data.money+'元'
                        //money:0+'元'
                    })
                }
  			})
    }
    
 	handleAsideFn(i){
        const arr = ['200','900','1800','']
        this.setState({
            asideNum:i
        })
        if(i===3){
            this.props.authenMsg(this.state.detailVla)
            this.props.history.push('/return-pc')

        }else{
            if(i===4)return
            window.scrollTo(0,arr[i])
        }
        
    }

 	handleVla(data){
        this.setState({
            detailVla:data
        })
    }
    
  	showRole(e){
        this.setState({
            showSelectWelfare:true,
            
        })
    }
	ToastBarClose(data){
		this.setState({
  			showSelectWelfare:false
  		})
	}
    render() {
        if(this.game_id==89){
            var ReturnListCon = ReturnListPC89
        }
        else if(this.game_id==791000306){
          var ReturnListCon = ReturnListPC7910
        }
        else if(this.game_id==78){
          var ReturnListCon = ReturnListPC78
        }
        else{
            var ReturnListCon = ReturnListPC
        }
        console.log(this.moneyArr)
        return(
            <div className="return-detail-pc-box">
                <HeaderPC></HeaderPC>
                <AuthenticatePC
                    propsAuthenticationData={this.propsAuthenticationData}
                    handleVla={this.handleVla}
                    gameInfo={this.state.gameInfo}
                ></AuthenticatePC>
                <div className="sdtq-box">
                    <div className="title">鉴定为回归用户，独享以下特权</div>
                    <div className="sdtq-top">
                        <div className="tq-names"><span className="gradients">定制礼包</span><i onClick={(e)=>this.showRole(e)}></i></div>
                    </div>
                    <ReturnListCon
                        key={this.state.parmeKey?2:false}
                        ikey={this.state.parmeKey?2:false}
                        inum='1'
                        accountData={this.state.accountData} 
                    ></ReturnListCon>
                </div>
                <div className="sdtq-box">
                        <div className="sdtq-top">
                            <div className="tq-names"><span className="gradients">高额返利</span><i onClick={(e)=>this.showRole(e)}></i></div>
                            {
                                this.props.authentication == 2 ? <div></div> : 
                                <div className="tq-tips">
                                    <span className="gradients">{this.gameXiaoHao}：</span><span onClick={()=>this.handleLogin()}>{this.state.money}</span>
                                </div>
                            }
                            <div className="return-step-box">
                                <div className="return-power-pc-box">
                                    <div className="return-power-num" style={{width: this.handlePower(this.state.money)}}></div>
                                    {
                                        this.game_id === '791000306' ? '' : 
                                        this.moneyArr.map((item, i) => (
                                            <i key={i}></i>
                                        ))
                                    }
                                </div>
                                {
                                    this.game_id==='791000306' ? 
                                    <div className="return-num-pc-box">
                                        <i>1元</i>
                                        <i>12888元</i>
                                    </div>
                                    :
                                    <div className="return-num-pc-box">
                                        {
                                            
                                            this.moneyArr.map((item, i) => (
                                                <i key={i}>{item + '元'}</i>
                                            ))
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                        <ReturnListCon
                            key={this.state.parmeKey?1:false}
                            ikey={this.state.parmeKey?1:false}
                            inum='2'
                            accountData={this.state.accountData} 
							iMoney={this.state.money}
                        ></ReturnListCon>
            
                </div>
                <aside className="aside-box">
                    <ul>
                        {
                            this.asideData.map((item,i)=>(
                                    <li 
                                    className={this.state.asideNum===i?'active-'+i+'':''}
                                    key={i} 
                                    onClick={()=>this.handleAsideFn(i)}
                                    >
                                        {
                                            this.props.match.params.id==='89'?
                                            <a href="http://act2.dn.sdo.com/Project/2019huigui/default.aspx" 
                                            target="_blank">
                                            </a>:''
                                        }
                                    </li>
                            ))
                        }
                    </ul>
                </aside>

                {
                    this.state.showSelectWelfare&&<ToastBar visible={this.state.showSelectWelfare} 
                        title={'领取规则'}  
                        isOkShow ={false} 
                        ToastBarClose={this.ToastBarClose}
                        
                    >	
                        {this.game_id==='89'?<ReturnGetALert></ReturnGetALert>:''}
                        {this.game_id==='791000306'?<ReturnGetALert7910></ReturnGetALert7910>:''}
                        {this.game_id==='78'?<ReturnGetALert78></ReturnGetALert78>:''}
                    </ToastBar>

                    
                }
            </div>
            
        )
    }
}
export default returnDetailPC;


// WEBPACK FOOTER //
// ./src/container/return-detail-pc/detail.js